export default __webpack_public_path__ + "static/media/auto_elek_1019_2.718e08e8.jpg";